import { call, takeEvery } from 'redux-saga/effects';
import { sendServiceSms } from 'api/modules/commuterPlans/api';
import types from './types';
export const smsSagas = [takeEvery(types.SEND_SMS_REQUEST, sendSms)];
export function* sendSms({
  serviceId,
  phoneNumber,
  promise
}) {
  try {
    yield call(sendServiceSms, serviceId, {
      phoneNumber
    });
  } catch (err) {
    if (promise) yield call(promise.reject);
  }
  if (promise) yield call(promise.resolve);
}